import { render, staticRenderFns } from "./footpage.vue?vue&type=template&id=5bf39ff1&scoped=true&"
import script from "./footpage.vue?vue&type=script&lang=js&"
export * from "./footpage.vue?vue&type=script&lang=js&"
import style0 from "./footpage.vue?vue&type=style&index=0&id=5bf39ff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf39ff1",
  null
  
)

export default component.exports